import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { ShowCustomArticleItemsRequest, ShowCustomArticleItemsResponse } from "./models"

export function showCustomArticleItems(body: ShowCustomArticleItemsRequest) {
    const url = `${WebserviceUrl.BasketCustomArticles}/ShowCustomArticleItems`
    return ajaxAuth<ShowCustomArticleItemsResponse>({ url, body }).then((response) => ({
        data: response?.customArticleItems ?? [],
        pageIndex: body.pageIndex,
        endOfList: (response?.customArticleItems?.length ?? 0) < body.pageSize,
    }))
}
